module.exports = __webpack_public_path__ + "img/deal.77547d29.svg";